import { ChangeDetectionStrategy, Component, inject, input, InputSignal } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'details-extra-fields',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './extra-fields.component.html',
  styleUrl: './extra-fields.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class DetailsExtraFieldsComponent {
  public translate = inject(TranslateService);
  public extraFields: InputSignal<any> = input.required<any>();
  public fromBottomSheet: InputSignal<any> = input.required<boolean>();
}